import BaseCommand from "@/models/api/commands/BaseCommand";

export class RemoveContractorCommand extends BaseCommand {
  CommandName = "RemoveContractor";
  Command = null;
  constructor(sessionId: string, operationId: string) {
    super(sessionId, operationId);
  }
}
